import axios from 'axios'
import { sanitize } from '@/js/utils/sanitize'
import { randomBaseUrl } from '@/js/utils/randomBaseUrl'

export const recordDerogation = params => new Promise((resolve, reject) => {

  let option = params.option ? params.option : 'json'
  let answerid = params.answerid ? sanitize(params.answerid) : null
  let moduleid = params.moduleid ? sanitize(params.moduleid) : null
  let path = params.path ? sanitize(params.path) : null
  let value = params.value ? sanitize(params.value) : null
  let key = sanitize(params.key)

  option = option ? option : 'json'
  answerid = answerid ? encodeURIComponent(answerid) : null
  moduleid = moduleid ? encodeURIComponent(moduleid) : null
  path = path ? encodeURIComponent(path) : null
  value = value ? encodeURIComponent(value) : null
  key = encodeURIComponent(key)

  let uri = option === 'delete' ? '?options=delete' : '?options=json'
  uri = key && key !== '' &&
        key !== undefined && key !== 'undefined' &&
        key !== null && key !== 'null' ?
        `${uri}&valid=${key}` : uri
  uri = answerid && answerid !== '' &&
        answerid !== undefined && answerid !== 'undefined' &&
        answerid !== null && answerid !== 'null' ?
        `${uri}&answerid=${answerid}` : uri
  uri = moduleid && moduleid !== '' &&
        moduleid !== undefined && moduleid !== 'undefined' &&
        moduleid !== null && moduleid !== 'null' ?
        `${uri}&moduleid=${moduleid}` : uri
  uri = path && path !== '' &&
        path !== undefined && path !== 'undefined' &&
        path !== null && path !== 'null' ?
        `${uri}&path=${path}` : uri
  uri = value && value !== '' &&
        value !== undefined && value !== 'undefined' &&
        value !== null && value !== 'null' ?
        `${uri}&value=${value}` : uri

  // ?answerid=answerid&moduleid=moduleid&options=json&path=path&valid=validkey&value=value


//   axios.get(process.env.VUE_APP_RECORD_DEROGATION + uri)
  axios({
    method: 'post',
    url: randomBaseUrl(0, 3) + process.env.VUE_APP_RECORD_DEROGATION,
    data: uri
  })
    .then(response => {
      resolve(response)
    })
    .catch(error => {
      reject(error)
    })
})
